import CryptoJS from "crypto-js";
const secret_key = process.env.REACT_APP_SECRET_KEY;
const iv = process.env.REACT_APP_SECRET_IV
function encrypt(data) {
  try {
    if (typeof data !== "string") {
      data = JSON.stringify(data);
    }
    const result = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(secret_key),{iv:CryptoJS.enc.Utf8.parse(iv)}).toString();
    return result;
  } catch (error) {
    console.error(error);
  }
}
export default encrypt;
